export const getProveedores = 'proveedores'
export const getAdministradores = 'administradores'
export const getClientes = 'clientes'
export const clearPassword = 'password-reset'
export const updateUser = 'administradores'
